"use client";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Spinner from "./spinner/spinner";
import { Card } from "@/components/ui/card";
import { get_all } from "@/services/search-service";

export type JobSummary = {
    items: number;
    job_id: string;
    last_updated: string;
};

interface IProps {
    isLoading: boolean;
    jobs: JobSummary[]
}

export default function JobList({ isLoading, jobs }: IProps) {
    const navigate = useNavigate();

    function onSelectJob(job_id: string) {
        navigate(`/job/${job_id}`);
    }

    return (
        <div className="space-y-4">
            <div className="flex items-center justify-between">
                <h2 className="text-lg font-mono">Job History</h2>
            </div>

            {isLoading && <Spinner />}

            {jobs.map((j) => (
                <Card
                    key={j.job_id}
                    className="cursor-pointer hover:bg-background/30 transition"
                    onClick={() => onSelectJob(j.job_id)}
                >
                    <div className="p-4 flex justify-between">
                        <div className="font-mono text-sm">{j.job_id.slice(0, 8)}...</div>
                        <div className="text-xs text-muted-foreground">
                            {j.items} platforms • {new Date(j.last_updated).toLocaleString()}
                        </div>
                    </div>
                </Card>
            ))}
        </div>
    );
}
